/* eslint-disable react/no-unused-state */
/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import Helmet from 'preact-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'preact-redux';
import { EVENT_BUS_EVENTS } from '../../utils/consts';
import * as calls from '../../actions/calls';
import { changeLocaleLangs, changeLocale, getUnreadMessages } from '../../actions/user';
// eslint-disable-next-line import/no-cycle
import AllActivity from '../../components/profile/all-activity';
import SideBar from '../../components/search/dropdown';
import Search from '../../components/search/input';

import style from './style.scss';

import { langPack } from '../../utils/langPack';

const proSortingItems = [{
  name: '',
  value: '',
},
{
  name: 'Last activity date',
  value: 'date',
}, {
  name: 'Name',
  value: 'name',
}, {
  name: 'Profession',
  value: 'service',
}];

class ActivityPros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searching: false,
    };
  }

  componentDidMount() {
    const {
      getUnreadMessages: dispatchGetUnreadMessages,
      changeLocaleLangs: dispatchChangeLocaleLangs,
      changeLocale: dispatchChangeLocale,
      eventBus,
      userData: { userAuth },
    } = this.props;

    dispatchGetUnreadMessages();

    if (userAuth) {
      this.getData();
    }
    dispatchChangeLocaleLangs([]);
    dispatchChangeLocale();

    eventBus.on(EVENT_BUS_EVENTS.PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
  }


  componentWillReceiveProps(nextProps) {
    const { userData: { userAuth: prevUserAuth }, sortBy: prevSortBy } = this.props;
    const { userData: { userAuth: nextUserAuth }, sortBy: nextSortBy } = nextProps;

    if (nextUserAuth !== prevUserAuth || nextSortBy !== prevSortBy) {
      this.getData();
    }
  }

  componentWillUnmount() {
    const { reset, eventBus } = this.props;
    reset();

    eventBus.removeListener(EVENT_BUS_EVENTS.PRESENCE_CHANGED_TO_ONLINE, this.onPresenceAvailable, this);
  }

  onSearch = () => {
    this.getData();
  };

  getData = (page = 1) => {
    this.props.getCalls(false, page);
  };

  changePage = (page) => {
    this.props.changeSearchParams({
      type: 'page',
      value: page,
    });
    window.scrollTo(0, 0);
    this.getData(page);
  };

  showConsulted = () => this.setState({ proCalls: false });

  showConsultedMe = () => this.setState({ proCalls: true });

  sortToggleSwitched = (sortBy) => {
    this.props.changeSearchParams({
      type: 'sortBy',
      value: sortBy,
    });
  };

  changeSearchTerm = (value) => {
    this.props.changeSearchParams({
      type: 'searchTerm',
      value,
    });
  };

  onPresenceAvailable = () => {
    const { page, getUnreadMessages: dispatchGetUnreadMessages } = this.props;

    dispatchGetUnreadMessages();
    this.getData(page);
  }

  render({ isProCalls, loading, page, activity, total, sortBy, searchTerm, timeOffset, badges: { badges }, locale }, { proCalls }) {
    return (
      <div id="profile" className="uk-container uk-container-small">
        <Helmet
          title={langPack[locale].ROUTES.TELMIE_MY_PROS}
        />
        <div>
          <div className={style.offset} />
          <div className={style.content}>
            <div className={style.title}>
              <h1>
                {langPack[locale].MISC.MY_PROS}
              </h1>
              <SideBar
                onChange={this.sortToggleSwitched}
                data={proSortingItems}
                selected={sortBy}
              />
              <Search
                onChange={this.changeSearchTerm}
                onSearch={this.onSearch}
                value={searchTerm}
                placeholder={langPack[locale].ROUTES.FIND_YOUR_PRO}
                className={style.search}
                locale={locale}
              />
            </div>
            <AllActivity
              showConsultedMe={this.showConsultedMe}
              showConsulted={this.showConsulted}
              activity={activity}
              currentPage={page}
              client={isProCalls}
              loading={loading}
              changePage={this.changePage}
              nextPage={this.nextPage}
              previousPage={this.previousPage}
              proCalls={proCalls}
              total={total}
              searchValue={searchTerm}
              timeOffset={timeOffset}
              locale={locale}
              badges={badges}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.loggedInUser,
  proCalls: state.loggedInUserProCalls,
  personalCalls: state.loggedInUserPersonalCalls,
  activity: state.calls.activity,
  sortBy: state.calls.sortBy,
  page: state.calls.page,
  searchTerm: state.calls.searchTerm,
  loading: state.calls.loading,
  total: state.calls.total,
  timeOffset: state.communicateModal.offset,
  locale: state.locale.locale,
  badges: state.badges.data || {},
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getCalls: calls.getCalls,
  changeSearchParams: calls.changeSearchParams,
  reset: calls.reset,
  changeLocaleLangs,
  changeLocale,
  getUnreadMessages,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActivityPros);



// WEBPACK FOOTER //
// ./routes/activity/pros.js